import React from "react";
import { Header, Segment, Feed } from "semantic-ui-react";
import SingleEvent from "../components/SingleEvent";

const EventLog = (props) => (
  <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 220, height: "100%" }}>
    <Header as="h2" attached="top">
      {props.header}
    </Header>
    <Segment attached style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
      <Feed style={{ flex: 1, overflowY: "auto", minHeight: 0, height: "100%" }}>
        {props.events.map((data, i) => (
          <SingleEvent key={`${data.session_id}_event_${i}`} {...data} />
        ))}
      </Feed>
    </Segment>
  </div>
);

export default EventLog;
